/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGanttChartPageTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M5 13h2v-2H5v2zm2 2H5v2h2v-2z" fill="currentcolor" />
      <path
        d="M22 2H2v20h20V2zM4 6V4h16v2H4zm0 2h16v3h-5V9h-1v2H9v2h5v2h-3v2h3v2h1v-2h5v3H4V8zm11 7v-2h5v2h-5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgGanttChartPageTemplate as GanttChartPageTemplate };
